import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-36dab412")

_pushScopeId("data-v-36dab412")
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "nav__title" }
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = {
  id: "action",
  class: "action"
}
const _hoisted_6 = { class: "action__in" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", {
  class: "action__label",
  for: "in"
}, "Entrada", -1)
const _hoisted_8 = { class: "action__out" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  class: "action__label",
  for: "out"
}, "Saída", -1)
const _hoisted_10 = { class: "actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_OCalendar = _resolveComponent("OCalendar")
  const _component_FormField = _resolveComponent("FormField")
  const _component_SelectFish = _resolveComponent("SelectFish")
  const _component_SelectPond = _resolveComponent("SelectPond")
  const _component_ORadioButton = _resolveComponent("ORadioButton")
  const _component_OInputNumber = _resolveComponent("OInputNumber")
  const _component_OTextarea = _resolveComponent("OTextarea")
  const _component_UserLog = _resolveComponent("UserLog")
  const _component_OButton = _resolveComponent("OButton")
  const _component_BlockUI = _resolveComponent("BlockUI")
  const _directive_focus = _resolveDirective("focus")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BlockUI, { blocked: _ctx.busy }, {
      default: _withId(() => [
        _createVNode(_component_NavBar, { navigation: "back" }, {
          body: _withId(() => [
            _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_FormField, {
              label: "Data",
              invalid: _ctx.v$.form.datetime.$invalid && _ctx.submitted,
              loading: _ctx.loading,
              "invalid-message": "Data inválida."
            }, {
              default: _withId(() => [
                _createVNode(_component_OCalendar, {
                  modelValue: _ctx.form.datetime,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.datetime = $event)),
                  class: { 'p-invalid': _ctx.v$.form.datetime.$invalid && _ctx.submitted },
                  "show-icon": "",
                  placeholder: "Data",
                  "touch-u-i": "",
                  "data-test": "datetime"
                }, null, 8, ["modelValue", "class"])
              ]),
              _: 1
            }, 8, ["invalid", "loading"]),
            _createVNode(_component_FormField, {
              label: "Peixe",
              invalid: _ctx.v$.form.fish.$invalid && _ctx.submitted,
              loading: _ctx.loading,
              "invalid-message": "Peixe inválido.",
              "data-test": "fieldFish"
            }, {
              default: _withId(() => [
                _withDirectives(_createVNode(_component_SelectFish, {
                  modelValue: _ctx.form.fish,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.fish = $event)),
                  class: { 'p-invalid': _ctx.v$.form.fish.$invalid && _ctx.submitted },
                  "data-test": "fish"
                }, null, 8, ["modelValue", "class"]), [
                  [_directive_focus, !_ctx.hasQueryString]
                ])
              ]),
              _: 1
            }, 8, ["invalid", "loading"]),
            _createVNode(_component_FormField, {
              label: "Açude",
              invalid: _ctx.v$.form.pond.$invalid && _ctx.submitted,
              loading: _ctx.loading,
              "invalid-message": "Açude inválido.",
              "data-test": "fieldPond"
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectPond, {
                  modelValue: _ctx.form.pond,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.pond = $event)),
                  class: { 'p-invalid': _ctx.v$.form.pond.$invalid && _ctx.submitted },
                  "data-test": "pond"
                }, null, 8, ["modelValue", "class"])
              ]),
              _: 1
            }, 8, ["invalid", "loading"]),
            _createVNode(_component_FormField, {
              label: "Tipo",
              loading: _ctx.loading,
              "invalid-message": "Tipo inválido."
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode(_component_ORadioButton, {
                      id: "in",
                      modelValue: _ctx.form.action,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.action = $event)),
                      name: "action",
                      value: "IN",
                      "data-test": "actionIn"
                    }, null, 8, ["modelValue"]),
                    _hoisted_7
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_ORadioButton, {
                      id: "out",
                      modelValue: _ctx.form.action,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.action = $event)),
                      name: "action",
                      value: "OUT",
                      "data-test": "actionOut"
                    }, null, 8, ["modelValue"]),
                    _hoisted_9
                  ])
                ])
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_FormField, {
              label: "Quantidade",
              invalid: _ctx.v$.form.quantity.$invalid && _ctx.submitted,
              loading: _ctx.loading,
              "invalid-message": "Quantidade inválida.",
              "data-test": "fieldQuantity"
            }, {
              default: _withId(() => [
                _withDirectives(_createVNode(_component_OInputNumber, {
                  modelValue: _ctx.form.quantity,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.quantity = $event)),
                  inputmode: "numeric",
                  locale: "pt-BR",
                  placeholder: "Quantidade",
                  class: { 'p-invalid': _ctx.v$.form.quantity.$invalid && _ctx.submitted },
                  "data-test": "quantity"
                }, null, 8, ["modelValue", "class"]), [
                  [_directive_focus, _ctx.hasQueryString]
                ])
              ]),
              _: 1
            }, 8, ["invalid", "loading"]),
            _createVNode(_component_FormField, {
              label: "Observações",
              loading: _ctx.loading
            }, {
              default: _withId(() => [
                _createVNode(_component_OTextarea, {
                  modelValue: _ctx.form.notes,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.notes = $event)),
                  "auto-resize": "",
                  placeholder: "Observações",
                  "data-test": "notes"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          (_ctx.userLog.createdBy || _ctx.userLog.modifiedBy)
            ? (_openBlock(), _createBlock(_component_UserLog, {
                key: 0,
                class: "user-log",
                data: _ctx.userLog
              }, null, 8, ["data"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_OButton, {
              class: "p-button-primary",
              "icon-pos": "right",
              label: "SALVAR",
              loading: _ctx.saving,
              "data-test": "save",
              onClick: _ctx.handleSave
            }, null, 8, ["loading", "onClick"]),
            (_ctx.editing)
              ? (_openBlock(), _createBlock(_component_OButton, {
                  key: 0,
                  class: "p-button-danger p-button-outlined",
                  "icon-pos": "right",
                  label: "DELETAR",
                  loading: _ctx.deleting,
                  "data-test": "delete",
                  onClick: _ctx.handleDelete
                }, null, 8, ["loading", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["blocked"])
  ]))
})